<template>
  <div
    class="mt-5 flex items-center justify-center rounded-2xl bg-white/10 py-40"
  >
    <div class="text-white">
      <p class="flex justify-center font-numeraWebRegular">
        Du er offline
      </p>
      <p class="font-national2">
        Denne funksjonen fungerer ikke offline.
      </p>
      <div class="flex justify-center">
        <UButton
          variant="filled"
          class="mt-5"
          size="sm"
          @click="$router.back()"
        >
          <div class="flex items-center justify-center">
            <UIcon
              name="arrow-left"
              size="sm"
              class="mr-2"
            />
            <span class="text-lg">Gå tilbake</span>
          </div>
        </UButton>
      </div>
    </div>
  </div>
</template>
